@if (!isLoading) {
<div>
  <div class="ot-row">
    <div class="otsc-prop-header">
      <h1 class="otsc-prop-header-text" i18n>General</h1>
      <div class="ot-btn-group otsc-prop-header-btn">
        <button id="otsc-settings-general-save-btn" role="button" class="ot-btn ot-btn--is-primary" (click)="save()"
          [disabled]="!settingsForm.dirty || settingsForm.invalid">
          {{savingBtn}}
        </button>
        <button id="otsc-settings-general-reset-btn" role="button" class="ot-btn ot-btn--is-secondary" (click)="reset()"
          [disabled]="!settingsForm.dirty" i18n>
          Reset
        </button>
      </div>
    </div>
  </div>
  <form [formGroup]="settingsForm" name="otsc-settings-general-form">
    <div class="ot-pt-1 ot-pb-1 ot-pl-1" style="height: calc(100vh - 150px);">
      <ng-scrollbar #scrollbarRef>
        <div id="otsc-settings-general">
          <div class="ot-row">
            <div class="ot-col ot-row__column">
              <app-checkbox [identifier]="'checkOnlineMode'" formControlName="checkOnlineModeCtrl" [toggle]="true"
                i18n-label [label]="'Online mode'" [descriptionId]="'otsc-settings-general-online-inst-text'"
                i18n-description
                [description]="'The Online mode allows you to execute tasks which require internet access, like automatically download patches and access the online help.'"
                i18n-arialabel [arialabel]="'Enable/disable online mode'">
              </app-checkbox>
            </div>
          </div>
        </div>
        <div id="otsc-settings-session">
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-33">
              <div class="ot-form-control" [ngClass]="{'ot-form-control--is-invalid' : sessionTimeoutCtrl.invalid}">
                <label class="ot-form-control__label" for="settingsSessionTimeout" i18n>
                  Session timeout
                </label>
                <div class="ot-form-control__input-group">
                  <input id="settingsSessionTimeout" formControlName="sessionTimeoutCtrl" i18n-placeholder
                    placeholder="Enter session timeout" type="number" maxlength="2"
                    class="ot-input ot-input--is-expanded">
                  <span class="ot-form-control__error-icon">
                  </span>
                </div>
                @if (sessionTimeoutCtrl.invalid) {
                <p id="invalidSessionTimeoutMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                  Invalid session timeout specified, the value can be set between 1 and 60.
                </p>
                }
                <p id="otsc-settings-general-sessionTimeout-inst-text" class="ot-form-control__info-text" i18n>
                  The maximum time a session can be idle before it expires. The value can be set between 1 and 60
                  minutes.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="otsc-settings-help-url">
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-33">
              <div class="ot-form-control" [ngClass]="{'ot-form-control--is-invalid' : helpURLCtrl.invalid}">
                <label class="ot-form-control__label" for="helpURLCtrl" i18n>
                  Help Server URL
                </label>
                <div class="ot-form-control__input-group">
                  <input id="settingsHelpURL" formControlName="helpURLCtrl" i18n-placeholder
                    placeholder="Enter Help Server URL" type="text" maxlength="2048"
                    class="ot-input ot-input--is-expanded">
                </div>
                @if (helpURLCtrl.invalid && helpURLCtrl.errors.URLDoesNotEndsWith) {
                <p id="helpURLNotEndsWithMsg" class="ot-form-control__error-text" i18n>
                  Help Server URL does not end with '/mapperpi'
                </p>
                }
                @if (helpURLCtrl.invalid && helpURLCtrl.errors.required) {
                <p id="helpURLRequiredMsg" class="ot-form-control__error-text" i18n>
                  Help Server URL is required
                </p>
                }
                @if (helpURLCtrl.invalid && helpURLCtrl.errors.InvalidProtocol) {
                <p id="helpURLInvalidProtocoldMsg" class="ot-form-control__error-text" i18n>
                  Help Server URL does not start with 'http://' or 'https://'
                </p>
                }
                <p id="otsc-settings-general-help-url-inst-text" class="ot-form-control__info-text" i18n>
                  The Help Server URL allows System Center to redirect online help requests to the OpenText Private Help
                  Server (PHS). The default OpenText Global Help Server (GHS) URL is <b>{{settings.defaultHelpURL}}</b>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
  </form>
</div>
} @else {
<div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter">
    </div>
  </div>
  <div class="ot-progress__text" i18n id="otsc-settings-general-loading">Loading...</div>
</div>
}